export default "__VITE_ASSET__BP4kwpNK__"